<template>
    <div class="preloader-practice">
        <span class="preloader-practice__progressbar"></span>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped src="@/css/components/preloader-practice.css"></style>